module.exports = __webpack_public_path__ + "static/media/bis.91a97c4e.png";